import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function CreateTaxRate(
    data
) {
    const unHashedJwt = await checkJwt()    

    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/country', {
            method: 'post',
            headers: { 
                'Authorization' : unHashedJwt                 
            },
            data: {
                "country_name": data.country_name,
                "country_alpha2_code": data.country_alpha2_code,
                "country_alpha3_code": data.country_alpha3_code,
                "country_un_code": data.country_un_code,
                "fiscalize": data.fiscalize
            }      
        }).then(res => res)
        .catch(error => error.response.data)
    );
}